var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg46615252480558(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.218,
    style: {
      fill: "#EEEEEE"
    },
    width: 749.999,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#DED8D5",
      strokeWidth: 1.9678,
      strokeMiterlimit: 10
    },
    x1: 125.977,
    y1: 158.678,
    x2: 625.346,
    y2: 158.678
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DED8D5",
      strokeWidth: 1.9678,
      strokeMiterlimit: 10
    },
    d: "M618.825,434.908H132.498 c-3.602,0-6.521-2.92-6.521-6.521V132.464c0-3.602,2.92-6.521,6.521-6.521h486.327c3.602,0,6.521,2.92,6.521,6.521v295.922 C625.346,431.988,622.426,434.908,618.825,434.908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M158.887,142.644c0,2.523-2.045,4.568-4.568,4.568c-2.523,0-4.568-2.045-4.568-4.568 c0-2.523,2.045-4.568,4.568-4.568C156.842,138.077,158.887,140.122,158.887,142.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD254"
    },
    d: "M176.639,142.644c0,2.523-2.045,4.568-4.568,4.568c-2.523,0-4.568-2.045-4.568-4.568 c0-2.523,2.045-4.568,4.568-4.568C174.594,138.077,176.639,140.122,176.639,142.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857B"
    },
    d: "M194.392,142.644c0,2.523-2.045,4.568-4.568,4.568s-4.568-2.045-4.568-4.568 c0-2.523,2.045-4.568,4.568-4.568S194.392,140.122,194.392,142.644z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M690.218,268.936H572.856c-3.309,0-5.991-2.682-5.991-5.991V154.404 c0-3.309,2.682-5.991,5.991-5.991h117.362c3.309,0,5.991,2.682,5.991,5.991v108.542 C696.209,266.254,693.527,268.936,690.218,268.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DED8D5",
      strokeWidth: 1.9678,
      strokeMiterlimit: 10
    },
    d: "M690.218,268.936H572.856 c-3.309,0-5.991-2.682-5.991-5.991V154.404c0-3.309,2.682-5.991,5.991-5.991h117.362c3.309,0,5.991,2.682,5.991,5.991 v108.542C696.209,266.254,693.527,268.936,690.218,268.936z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M601.23,237.584h60.998c3.326,0,6.022-2.696,6.022-6.022v-49.991 c0-3.326-2.696-6.022-6.022-6.022H601.23c-3.326,0-6.022,2.696-6.022,6.022v49.991 C595.208,234.888,597.904,237.584,601.23,237.584z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.6466,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 648.391,216.882 619.84,216.882 614.683,216.882 614.683,194.276 648.391,194.276 648.391,199.927  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.6466,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 614.683,194.276 631.537,207.558 648.391,194.276  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M173.749,359.825H61.824c-3.155,0-5.713-2.558-5.713-5.713v-97.584 c0-3.155,2.558-5.713,5.713-5.713h111.926c3.155,0,5.713,2.558,5.713,5.713v97.584 C179.463,357.267,176.905,359.825,173.749,359.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#DED8D5",
      strokeWidth: 1.9678,
      strokeMiterlimit: 10
    },
    d: "M173.749,359.825H61.824 c-3.155,0-5.713-2.558-5.713-5.713v-97.584c0-3.155,2.558-5.713,5.713-5.713h111.926c3.155,0,5.713,2.558,5.713,5.713v97.584 C179.463,357.267,176.905,359.825,173.749,359.825z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M146.521,338.823H88.471c-3.667,0-6.639-2.973-6.639-6.639v-56.06 c0-3.667,2.973-6.639,6.639-6.639h58.049c3.667,0,6.639,2.973,6.639,6.639v56.06 C153.16,335.85,150.187,338.823,146.521,338.823z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M103.671,290.541c-7.832,7.832-7.832,20.688,0,28.52c7.832,7.832,20.688,7.832,28.52,0 c7.832-7.832,7.832-20.688,0-28.52C124.359,282.709,111.503,282.709,103.671,290.541z M132.145,293.445h-6.427 c-0.645-2.019-1.475-4.037-2.499-6.057C126.779,288.469,129.877,290.61,132.145,293.445z M110.526,303.622 c0.003-2.606,0.311-5.212,0.955-7.818h12.9c0.645,2.606,0.952,5.212,0.955,7.818H110.526z M125.257,305.98 c-0.178,2.606-0.65,5.212-1.386,7.818h-11.881c-0.736-2.606-1.208-5.212-1.386-7.818H125.257z M117.931,286.608 c0.969,0,1.921,0.076,2.849,0.222c1.236,2.206,2.204,4.41,2.924,6.616h-11.547c0.72-2.205,1.688-4.41,2.924-6.616 C116.01,286.684,116.962,286.608,117.931,286.608z M112.643,287.389c-1.024,2.019-1.854,4.038-2.499,6.057h-6.427 C105.985,290.61,109.083,288.468,112.643,287.389z M102.115,295.803h7.361c-0.645,2.606-0.984,5.212-1.031,7.818h-8.669 C99.958,300.791,100.785,298.136,102.115,295.803z M102.115,313.799c-1.33-2.332-2.158-4.988-2.339-7.818h8.705 c0.127,2.606,0.541,5.212,1.228,7.818H102.115z M103.718,316.157h6.688c0.667,2.043,1.496,4.087,2.486,6.13 C109.227,321.233,106.038,319.058,103.718,316.157z M117.931,322.995c-0.808,0-1.604-0.053-2.384-0.155 c-1.112-2.228-2.058-4.455-2.82-6.683h10.407c-0.762,2.228-1.709,4.455-2.82,6.683 C119.535,322.942,118.739,322.995,117.931,322.995z M122.972,322.287c0.989-2.043,1.819-4.086,2.486-6.13h6.688 C129.825,319.058,126.636,321.233,122.972,322.287z M133.747,313.799h-7.594c0.687-2.606,1.101-5.212,1.228-7.818h8.704 C135.905,308.811,135.077,311.466,133.747,313.799z M136.086,303.622h-8.668c-0.047-2.606-0.386-5.212-1.031-7.818h7.361 C135.077,298.136,135.904,300.791,136.086,303.622z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M167.079,97.432H65.68c-2.095,0-3.793-1.698-3.793-3.793l0,0c0-2.095,1.698-3.793,3.793-3.793 h101.398c2.095,0,3.793,1.698,3.793,3.793l0,0C170.872,95.734,169.174,97.432,167.079,97.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56DFED"
    },
    d: "M694.35,345.116h-49.215c-2.095,0-3.793-1.698-3.793-3.793l0,0c0-2.095,1.698-3.793,3.793-3.793 h49.215c2.095,0,3.793,1.698,3.793,3.793l0,0C698.143,343.418,696.444,345.116,694.35,345.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M659.881,388.993h-6.014c-1.58,0-2.861-1.281-2.861-2.861v-5.645c0-1.58,1.281-2.861,2.861-2.861 h6.014c1.58,0,2.861,1.281,2.861,2.861v5.645C662.742,387.712,661.461,388.993,659.881,388.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M89.834,415.271H83.82c-1.58,0-2.861-1.281-2.861-2.861v-5.645c0-1.58,1.281-2.861,2.861-2.861 h6.014c1.58,0,2.861,1.281,2.861,2.861v5.645C92.695,413.99,91.414,415.271,89.834,415.271z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M550.109,93.514H450.025c-1.663,0-3.012-1.348-3.012-3.012V66.066 c0-1.663,1.349-3.012,3.012-3.012h100.084c1.663,0,3.012,1.349,3.012,3.012v24.436 C553.12,92.166,551.772,93.514,550.109,93.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1803,
      strokeMiterlimit: 10
    },
    x1: 461.466,
    y1: 73.908,
    x2: 532.644,
    y2: 73.908
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1803,
      strokeMiterlimit: 10
    },
    x1: 461.466,
    y1: 81.213,
    x2: 490.457,
    y2: 81.213
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB1A5"
    },
    points: "458.571,90.068 458.571,101.939 473.5,90.068  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56DFED"
    },
    d: "M304.215,95.326h-48.448c-4.706,0-8.521-3.815-8.521-8.521V41.764 c0-3.568,2.892-6.46,6.46-6.46h50.509c3.568,0,6.46,2.892,6.46,6.46v47.103C310.675,92.434,307.783,95.326,304.215,95.326z "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.763,69.754l-3.612-3.612c-0.645-0.709-1.483-1.096-2.322-1.096 c-0.839,0-1.677,0.387-2.322,1.032l-2.064,2.064c-0.129-0.064-0.258-0.129-0.387-0.193c-0.258-0.129-0.451-0.193-0.645-0.323 c-1.935-1.225-3.676-2.838-5.353-4.902c-0.774-0.967-1.354-1.87-1.677-2.644c0.516-0.451,0.967-0.967,1.419-1.419 c0.193-0.194,0.387-0.387,0.58-0.58c0.709-0.709,1.096-1.548,1.096-2.386c0-0.839-0.387-1.677-1.096-2.386l-1.806-1.806 c-0.193-0.193-0.387-0.387-0.581-0.645c-0.387-0.387-0.838-0.838-1.225-1.225c-0.645-0.645-1.483-1.032-2.322-1.032 c-0.838,0-1.612,0.323-2.322,1.032l-2.257,2.257c-0.838,0.838-1.354,1.935-1.483,3.16c-0.129,1.935,0.387,3.741,0.838,4.902 c1.032,2.967,2.644,5.611,5.03,8.449c2.902,3.418,6.32,6.127,10.319,8.062c1.483,0.709,3.547,1.548,5.805,1.741 c0.129,0,0.258,0,0.452,0c1.548,0,2.838-0.58,3.87-1.677c0,0,0,0,0.065-0.064c0.322-0.387,0.709-0.774,1.161-1.161 c0.258-0.258,0.58-0.58,0.838-0.838C295.117,73.043,295.117,71.108,293.763,69.754z M292.279,73.107 c-0.258,0.258-0.516,0.516-0.774,0.774c-0.451,0.387-0.838,0.839-1.29,1.29c-0.645,0.645-1.354,0.967-2.322,0.967 c-0.129,0-0.193,0-0.322,0c-1.935-0.129-3.741-0.903-5.031-1.548c-3.676-1.806-6.901-4.321-9.61-7.546 c-2.193-2.644-3.676-5.16-4.708-7.804c-0.645-1.548-0.903-2.773-0.774-3.999c0.064-0.709,0.322-1.354,0.903-1.87l2.193-2.193 c0.193-0.193,0.516-0.451,0.903-0.451c0.387,0,0.645,0.194,0.903,0.451c0.387,0.387,0.774,0.774,1.161,1.161 c0.194,0.194,0.387,0.451,0.645,0.645l1.806,1.806c0.194,0.193,0.452,0.58,0.452,0.903c0,0.387-0.258,0.709-0.452,0.903 c-0.193,0.193-0.387,0.387-0.58,0.58c-0.581,0.581-1.096,1.096-1.612,1.612c0,0,0,0-0.064,0.064 c-0.645,0.645-0.516,1.225-0.387,1.612v0.064c0.451,1.161,1.161,2.193,2.128,3.483c1.806,2.257,3.741,3.999,5.869,5.353 c0.258,0.193,0.58,0.323,0.838,0.451c0.258,0.129,0.451,0.193,0.645,0.323l0.065,0.064c0.645,0.322,1.29,0.193,1.806-0.323 l2.257-2.257c0.194-0.193,0.516-0.451,0.903-0.451c0.322,0,0.645,0.258,0.838,0.451l3.612,3.612 C292.86,71.817,292.86,72.462,292.279,73.107z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 171.975,
    y: 101.416,
    width: 459.273,
    height: 332.684
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017500074185228210300000006824749571850821566_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017500074185228210300000006824749571850821566_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E716C"
    },
    d: "M514.962,322.582l-36.502-4.861l0.285,3.625l-31.208,4.156c0,0-20.117,50.469-2.387,161.465 h25.387l9.137-112.549h3.245l8.85,112.549h25.387C534.884,375.971,514.962,322.582,514.962,322.582z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.2333,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 468.067,
    y1: 374.418,
    x2: 494.553,
    y2: 374.418
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M536.279,269.341c-3.123-4.985-20.665-4.808-21.591-4.917 c-4.742-0.556,3.041,37.18,12.906,70.166c1.891,6.324,8.85,9.618,14.927,7.042c0.066-0.028,0.131-0.056,0.197-0.084 c4.807-2.036,7.543-7.14,6.576-12.271C544.602,304.387,539.891,275.104,536.279,269.341z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3978E"
    },
    points: "540.46,282.986 518.064,291.677 515.964,281.051 539.155,275.265  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M544.69,304.245c0,0-10.61,14.249-10.104,13.594c0.506-0.655,8.321-23.027,8.321-23.027 L544.69,304.245z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M559.86,285.092l-30.412,39.404c-3.993,5.173-2.718,12.654,2.764,16.212h0 c5.472,3.552,12.811,1.685,15.92-4.051l25.314-46.704L559.86,285.092z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M567.731,295.211c-6.593-2.13-10.211-9.201-8.081-15.794 c2.13-6.593,9.201-10.211,15.794-8.081c6.593,2.13,10.211,9.201,8.081,15.794 C581.396,293.723,574.324,297.341,567.731,295.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M580.735,275.733c0,0,3.433-3.565-2.657-6.063c-6.09-2.498-13.62-1.925-18.427,9.747 L580.735,275.733z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372F5F"
    },
    d: "M587.044,250.831l12.734,5.521c0.708,0.307,0.966,1.147,0.576,1.876l-16.752,31.29 c-0.39,0.729-1.281,1.071-1.989,0.764l-12.734-5.521c-0.708-0.307-0.966-1.147-0.576-1.876l16.752-31.29 C585.445,250.866,586.336,250.524,587.044,250.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261B43"
    },
    d: "M585.828,250.277l12.734,5.521c0.708,0.307,0.966,1.147,0.576,1.876l-16.752,31.29 c-0.39,0.729-1.281,1.071-1.989,0.764l-12.734-5.521c-0.708-0.307-0.966-1.147-0.576-1.876l16.752-31.29 C584.229,250.312,585.12,249.97,585.828,250.277z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "584.391,253.461 595.58,258.312 581.928,283.813 570.739,278.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "595.58,258.312 570.739,278.962 584.391,253.461  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M574.422,268.631c0,0,2.835,0.553,5.394,2.003c1.127,0.638,1.705,1.94,1.392,3.197l0,0 c-0.285,1.146-1.246,2-2.418,2.147l-6.62,0.835c0,0-3.454,5.953-7.967,6.622l4.14-10.452L574.422,268.631z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56DFED"
    },
    d: "M489.877,219.721c-0.731-0.004,46.946,6.597,54.814,60.955l-24.74,3.79l-4.988,41.036h-69.016 l-13.702-75.82c0,0,15.29-21.914,43.682-29.962H489.877z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.2333,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 519.951,
    y1: 284.466,
    x2: 522.098,
    y2: 260.732
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M494.408,220.498v-18.881h-22.126v19.103c-1.132,0.338-3.017,1.02-5.944,2.411l17.257,10.28 l17.642-10.28C501.237,223.13,498.437,221.502,494.408,220.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M472.077,203.924c0,0,3.974,10.551,14.582,9.641c9.749-0.837,8.198-15.46,8.198-15.46 L472.077,203.924z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M462.427,189.891c-3.468,3.146-11.223-8.786-7.872-12.136c3.351-3.35,5.907,1.906,5.907,1.906 l1.496,3.561l1.129,4.824l0.268,1.263L462.427,189.891z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 0.9928,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M456.175,181.982c0,0,2.625-1.181,4.957,2.625"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M503.441,189.529c3.19,3.428,11.926-7.805,8.87-11.426c-3.056-3.621-6.047,1.399-6.047,1.399 l-1.792,3.422l-1.533,4.711l-0.374,1.236L503.441,189.529z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 0.9928,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M510.34,182.177c0,0-2.516-1.399-5.161,2.196"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M456.344,166.374c0,15.794,12.042,23.284,26.896,23.284s26.896-7.489,26.896-23.284 c0-15.794-12.042-26.539-26.896-26.539S456.344,150.579,456.344,166.374z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M460,167.472c0,9.696,1.37,18.063,2.737,24.001c1.339,5.814,5.107,9.877,10.431,13.147 l0.97,0.596c5.633,3.46,12.912,3.541,18.632,0.206l0,0c5.769-3.363,9.808-7.797,11.051-14.036 c2.261-11.348,2.508-23.915,2.508-23.915s2.151-24.477-22.834-24.001C458.51,143.947,460,167.472,460,167.472z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.2316,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M481.648,181.441v3.387c0,0.201,0.039,0.393,0.109,0.569c0.278,0.692,1.077,1.024,1.799,0.832l1.553-0.412"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M477.675,168.306l-12.417,2.91c0,0,0.564-3.16,5.644-4.308 C475.982,165.76,477.675,168.306,477.675,168.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M488.696,168.306l11.99,2.91c0,0-0.545-3.16-5.45-4.308 C490.331,165.76,488.696,168.306,488.696,168.306z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#282828"
    },
    cx: 472.958,
    cy: 177.428,
    rx: 2.094,
    ry: 2.088
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M494.904,177.428c0,1.153-0.938,2.088-2.094,2.088c-1.157,0-2.094-0.935-2.094-2.088 s0.938-2.088,2.094-2.088C493.967,175.339,494.904,176.274,494.904,177.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M475.052,190.172h16.148C491.201,190.172,484.043,198.878,475.052,190.172z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 12.2341 386.0138)",
    style: {
      fill: "none",
      stroke: "#C98BD2",
      strokeWidth: 1.3423,
      strokeMiterlimit: 10
    },
    cx: 472.077,
    cy: 178.239,
    rx: 8.905,
    ry: 8.905
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 18.6413 401.4823)",
    style: {
      fill: "none",
      stroke: "#C98BD2",
      strokeWidth: 1.3423,
      strokeMiterlimit: 10
    },
    cx: 493.953,
    cy: 178.239,
    rx: 8.905,
    ry: 8.905
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C98BD2",
      strokeWidth: 1.3423,
      strokeMiterlimit: 10
    },
    d: "M480.982,178.239 c0,0,2.109-1.968,4.066,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C98BD2",
      strokeWidth: 1.3423,
      strokeMiterlimit: 10
    },
    x1: 463.172,
    y1: 178.239,
    x2: 460.367,
    y2: 178.168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C98BD2",
      strokeWidth: 1.3423,
      strokeMiterlimit: 10
    },
    x1: 502.858,
    y1: 178.239,
    x2: 505.679,
    y2: 178.168
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M506.007,175.587c0,0-9.989-13.504-7.685-27.185c0,0,7.414,3.731,9.345,13.362 C509.598,171.394,506.007,175.587,506.007,175.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M459.983,176.502c0,0,11.604-15.338,9.3-29.019c0,0-8.048,4.65-9.979,14.28 C457.373,171.394,459.983,176.502,459.983,176.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M505.169,153.79c0,0-12.827,14.042-47.92,11.638c0,0,5.374-20.606,22.381-22.8 C479.63,142.628,499.267,140.283,505.169,153.79z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1594 -0.9872 0.9872 0.1594 288.2938 613.3089)",
    style: {
      fill: "#282828"
    },
    cx: 504.268,
    cy: 137.375,
    rx: 16.756,
    ry: 16.756
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M299.725,322.544l-31.208-4.156l0.285-3.625l-36.502,4.861c0,0-19.922,53.389-2.192,164.385 h25.387l8.85-112.549h3.245l9.137,112.549h25.387C319.841,373.013,299.725,322.544,299.725,322.544z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M297.235,170.7c-4.224-4.969-7.606-10.766-10.48-18.901c-3.086-8.732-13.189-5.183-13.189-5.183 s-8.419-10.831-21.088-7.059c-12.669,3.772-17.071,12.788-17.329,23.506c-0.258,10.718-8.689,12.395-15.181,24.794 c-11.461,21.89,7.835,40.327,42.959,35.213l0.047-0.341c3.458,1.05,7.698,1.509,12.873,1.202 C318.043,221.426,313.971,190.389,297.235,170.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M283.421,186.933c3.468,3.146,11.223-8.786,7.872-12.136s-5.907,1.906-5.907,1.906 l-1.496,3.562l-1.129,4.824l-0.268,1.263L283.421,186.933z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 0.9928,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M289.673,179.023c0,0-2.625-1.181-4.957,2.625"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M242.408,186.571c-3.19,3.428-11.926-7.805-8.87-11.426c3.056-3.621,6.047,1.399,6.047,1.399 l1.792,3.422l1.533,4.711l0.374,1.236L242.408,186.571z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 0.9928,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.508,179.219c0,0,2.516-1.399,5.161,2.196"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M289.503,163.415c0,15.794-12.042,23.284-26.896,23.284c-14.854,0-26.896-7.489-26.896-23.284 s12.042-26.539,26.896-26.539C277.462,136.876,289.503,147.621,289.503,163.415z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.44,
    y: 198.659,
    style: {
      fill: "#FFB1A5"
    },
    width: 22.126,
    height: 28.651
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M248.211,196.872c0,0,6.159,12.292,13.736,14.211c2.025,0.513,4.186,0.337,6.138-0.355 c2.852-1.011,6.468-5.263,7.083-9.968l0.285-2.688C275.454,198.073,261.971,205.414,248.211,196.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M285.848,164.514c0,9.696-1.37,18.063-2.737,24.001c-1.339,5.814-5.107,9.877-10.431,13.147 l-0.97,0.596c-5.633,3.46-12.912,3.541-18.632,0.206v0c-5.769-3.363-9.808-7.797-11.051-14.036 c-2.261-11.347-2.508-23.915-2.508-23.915s-2.151-24.477,22.834-24.001S285.848,164.514,285.848,164.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.2298,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M260.938,179.808v2.012c0,0.2,0.039,0.392,0.109,0.568c0.278,0.69,1.077,1.021,1.799,0.83l1.553-0.411"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M266.144,166.54l13.293,3.146c0,0-0.604-3.416-6.042-4.657 C267.956,163.787,266.144,166.54,266.144,166.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M259.165,166.54l-13.463,3.146c0,0,0.612-3.416,6.12-4.657 C257.329,163.787,259.165,166.54,259.165,166.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M254.342,174.79c0,1.15-0.938,2.082-2.094,2.082c-1.157,0-2.094-0.932-2.094-2.082 c0-1.15,0.938-2.082,2.094-2.082C253.405,172.708,254.342,173.641,254.342,174.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M274.194,174.79c0,1.15-0.938,2.082-2.094,2.082c-1.157,0-2.094-0.932-2.094-2.082 c0-1.15,0.938-2.082,2.094-2.082C273.257,172.708,274.194,173.641,274.194,174.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M252.959,186.699h18.379c0,0-1.297,5.05-9.631,5.05 C255.36,191.749,252.959,186.699,252.959,186.699z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M239.841,172.629c0,0,9.989-13.504,7.685-27.185c0,0-7.414,3.731-9.345,13.362 C236.25,168.435,239.841,172.629,239.841,172.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M285.865,172.179c0,0-11.604-13.973-9.3-27.654c0,0,8.048,4.65,9.979,14.28 S285.865,172.179,285.865,172.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M240.679,150.832c0,0,11.462,15.406,46.555,13.003c0,0-4.009-21.97-21.016-24.165 C266.218,139.67,246.581,137.325,240.679,150.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M208.689,390.312c-0.51,0.803,29.208-129.305,20.385-127.338 c-0.805,0.179-16.258,1.614-18.555,6.284c-6.658,13.536-11.432,120.067-11.432,120.067L208.689,390.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M199.087,389.326c0,0-4.79,22.225,13.318,24.655c1.193,0.16,2.346-0.544,2.739-1.682 l0.052-0.151c0.433-1.256-0.196-2.602-1.409-3.144c-2.952-1.32-7.532-4.655-5.259-12.23c0,0,2.617-0.321,4.062,4.561 c0.372,1.256,1.781,1.887,2.951,1.298l0,0c0.799-0.402,1.248-1.261,1.136-2.148c-0.434-3.42-2.155-11.652-8.755-13.861 L199.087,389.326z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M205.181,300.52c0,0,17.123,24.114,17.213,23.648c0.09-0.466,5.988-33.856,5.988-33.856 l-20.778-9L205.181,300.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00857B"
    },
    d: "M252.757,222.593c0.731-0.004-42.318,0.767-50.186,55.124l24.74,3.79l4.988,41.036h69.016 l13.702-75.82c0,0-9.741-16.427-38.133-24.475L252.757,222.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M231.716,229.164c0,0,6.084,8.076,31.011,8.076c24.695,0,31.01-8.499,31.01-8.499 s-14.558-8.134-31.451-10.765C262.286,217.975,247.202,220.662,231.716,229.164z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005683"
    },
    points: "316.414,401.367 316.474,509.772 370.102,509.772 374.224,401.367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005683"
    },
    points: "432.856,401.367 432.796,509.772 379.168,509.772 375.046,401.367  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.117,
    y: 401.367,
    style: {
      fill: "#005683"
    },
    width: 55.449,
    height: 37.662
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 355.862,
    y1: 439.028,
    x2: 394.107,
    y2: 439.028
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M466.735,306.763c3.325,36.734-0.182,63.499,0.787,131.092l-32.008,1.341l-4.77-126.522 L466.735,306.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M434.693,335.428c0,0,19.822-1.815,33.373-10.754l-0.357-7.867l-33.027,4.498L434.693,335.428 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M402.894,222.188c0,0,62.96,15.833,74.367,95.748c0,0-30.814,13.359-61.694,7.613l6.947-26.729 L402.894,222.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M214.833,255.417l46.878,55.361l-14.345,40.398c0,0-35.63-49.537-51.64-87.826 L214.833,255.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M216.374,257.415c0,0-16.461,9.3-20.648,5.936c-7.317-5.879-13.364-27.399-13.364-27.399 s30.782-11.605,30.493-11.151C212.567,225.254,216.374,257.415,216.374,257.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M216.374,257.415c-0.291-1.657,6.104-19.535,8.296-26.239 c0.529-1.617-0.586-3.39-2.341-3.726l0,0c-1.143-0.219-2.952-0.078-3.808,1.561l-7.721,13.196L216.374,257.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M215.81,238.089l-5.301-26.373c-0.314-1.755-2.078-2.964-3.837-2.632l0,0 c-1.523,0.288-2.527,1.644-2.347,3.171l2.31,19.638L215.81,238.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M205.269,228.361l-7.199-18.833c-0.595-1.649-2.451-2.563-4.09-2.014l0,0 c-1.421,0.476-2.218,1.908-1.882,3.378l5.342,21.761L205.269,228.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M197.532,233.914l-9.108-18.505c-0.836-1.717-2.916-2.515-4.623-1.772l0,0 c-1.604,0.697-2.314,2.514-1.627,4.166l7.261,17.47L197.532,233.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M182.363,235.952l-7.147-11.336c-0.592-1.334-0.046-2.829,1.249-3.421l0,0 c1.239-0.566,2.77-0.121,3.571,1.039l9.398,13.038L182.363,235.952z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.5317,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M214.37,236.107c0,0-10.733-1.126-11.836,13.178"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M237.859,332.282c0,0,8.817,30.513,26.386,26.456c17.57-4.057,44.953-41.582,44.953-41.582 l-6.129-64.074l-49.314,60.694L237.859,332.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M269.051,294.922c0,0,16.649,25.113,30.851,33.968l9.296-11.734l-35.861-27.741 L269.051,294.922z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M341.893,220.803c0,0-48.88,11.018-74.928,67.826c0,0,15.738,23.714,40.969,34.254 l16.892-20.694L341.893,220.803z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98BD2"
    },
    d: "M341.893,220.627c-19.094,9.794-31.098,22.783-31.098,22.783l3.767,166.06h120.327 l-0.39-165.203c0,0-15.168-14.842-31.606-22.078C388.932,216.042,355.467,213.665,341.893,220.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M398.83,301.544L398.83,301.544c-9.243,0-16.736-7.493-16.736-16.736v-16.737h33.473v16.737 C415.567,294.051,408.074,301.544,398.83,301.544z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 434.693,
    y1: 326.166,
    x2: 436.254,
    y2: 271.843
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 312.644,
    y1: 317.112,
    x2: 310.044,
    y2: 270.023
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M343.303,159.974l-5.016-24.815c-0.282-2.021-1.066-5.141-0.106-8.071 c1.589-4.849,7.428-14.162,17.407-9.898l2.157,9.825c0,0-10.364,2.092-14.521,15.65L343.303,159.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M354.853,122.313c-0.182,3.26-3.06,17.527-13.177,22.724 C341.676,145.037,332.814,126.031,354.853,122.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M390.346,216.058L390.346,216.058v-42.137h-38.844v42.137l-11.563,5.271 c0,0,2.712,17.464,31.392,17.851c28.681,0.387,31.562-16.992,31.562-16.992L390.346,216.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M355.588,117.191c0,0,7.129-18.806,29.112-8.808c13.305,6.051,17.032,14.165,18.618,19.913 c0.527,1.91,0.737,4.919,0.594,6.705l-5.318,24.973l-20.759-34.552l-20.089,1.593L355.588,117.191z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M398.594,159.974c0,0,2.619-4.165,8.02-2.117c5.401,2.049,2.958,15.166-5.144,16.838 c0,0-2.904,0.633-5.182-1.355C396.288,173.34,398.28,163.651,398.594,159.974z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M405.543,162.485c0,0-4.525-1.51-7.736,5.153"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3978E"
    },
    d: "M343.303,159.974c0,0-2.619-4.165-8.02-2.117c-5.401,2.049-2.958,15.166,5.144,16.838 c0,0,2.904,0.633,5.182-1.355C345.609,173.34,343.616,163.651,343.303,159.974z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M336.354,162.485c0,0,4.525-1.51,7.736,5.153"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB1A5"
    },
    d: "M399.135,147.526c0.003,7.908-0.774,24.452-5.635,34.272 c-4.565,9.22-12.114,14.182-22.011,14.477c-9.898,0.296-17.271-3.519-23.18-15.485c-5.909-11.966-5.627-33.117-5.627-33.117 s0-28.249,27.92-28.249C400.008,119.424,399.135,147.526,399.135,147.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M351.794,186.688c0,0,3.253,16.505,17.618,18.402c16.532,2.182,20.935-17.982,20.935-17.982 s-7.305,9.154-18.858,9.168C358.604,196.291,351.794,186.688,351.794,186.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M368.917,159.254v6.538c0,0.281,0.054,0.55,0.153,0.796c0.387,0.968,1.502,1.432,2.51,1.164l2.167-0.576"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M360.672,156.132c0,1.404-1.138,2.542-2.542,2.542c-1.404,0-2.542-1.138-2.542-2.542 c0-1.404,1.138-2.542,2.542-2.542C359.534,153.59,360.672,154.728,360.672,156.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M384.501,156.132c0,1.404-1.138,2.542-2.542,2.542c-1.404,0-2.542-1.138-2.542-2.542 c0-1.404,1.138-2.542,2.542-2.542C383.364,153.59,384.501,154.728,384.501,156.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M375.454,143.488l17.089,4.414c0,0-0.777-4.793-7.768-6.535 C377.784,139.625,375.454,143.488,375.454,143.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M364.835,143.488l-17.089,4.414c0,0,0.777-4.793,7.768-6.535 C362.505,139.625,364.835,143.488,364.835,143.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#282828",
      strokeWidth: 1.3968,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.436,172.379c0,0,2.521,1.932,9.15,1.932c6.029,0,9.794-1.932,9.794-1.932"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9514,
      strokeMiterlimit: 10
    },
    cx: 357.446,
    cy: 156.875,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9514,
      strokeMiterlimit: 10
    },
    cx: 383.978,
    cy: 156.875,
    r: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9514,
      strokeMiterlimit: 10
    },
    d: "M368.246,156.875 c0,0,2.558-2.387,4.932,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9514,
      strokeMiterlimit: 10
    },
    x1: 346.646,
    y1: 156.875,
    x2: 343.024,
    y2: 156.783
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9514,
      strokeMiterlimit: 10
    },
    x1: 394.779,
    y1: 156.875,
    x2: 398.821,
    y2: 156.809
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828"
    },
    d: "M351.794,122.957c0,0,5.187,14.735,28.591,14.283c15.903-0.307,19.703,11.201,19.703,11.201 s-2.768-25.727-3.496-25.484c-0.728,0.243-24.199-6.263-24.199-6.263L351.794,122.957z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M385.084,465.471c-0.432,0.443-0.803,0.931-1.108,1.453l-0.465-0.241 c-0.067-0.298-0.349-0.503-0.659-0.466c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.065-0.008,0.127-0.026,0.184-0.052l0.452,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.746,0.132 c0.23-1.306,0.85-2.507,1.792-3.472L385.084,465.471z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M390.572,463.169c-0.171,0-0.341,0.006-0.51,0.017l-0.074-0.626 c0.188-0.149,0.296-0.389,0.266-0.645c-0.046-0.393-0.402-0.674-0.795-0.628s-0.674,0.402-0.628,0.795 c0.03,0.254,0.189,0.461,0.405,0.564l0.073,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.942-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.158l0.161-0.741 C391.672,463.228,391.122,463.169,390.572,463.169z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M397.174,465.716c0.331-0.04,0.566-0.341,0.525-0.672 c-0.04-0.331-0.341-0.566-0.672-0.526c-0.309,0.038-0.535,0.304-0.53,0.609l-0.416,0.363c-0.418-0.43-0.89-0.813-1.408-1.139 l-0.404,0.641c1.134,0.715,2.021,1.726,2.563,2.925l0.69-0.313c-0.251-0.554-0.567-1.072-0.942-1.545l0.402-0.351 C397.045,465.721,397.109,465.724,397.174,465.716z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M390.024,473.377c-0.386,0.023-0.775,0.035-1.157,0.035 c-0.88,0-1.733-0.061-2.478-0.179c-0.39-0.062-0.846-0.155-1.27-0.292c1.046,1.861,3.069,3.125,5.388,3.125 c2.855,0,5.262-1.916,5.95-4.504c-0.682,0.449-1.505,0.825-2.459,1.123C392.818,473.052,391.443,473.292,390.024,473.377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M390.572,464.685c-3.352,0-6.08,2.666-6.08,5.944 c0,0.425,0.046,0.849,0.137,1.261c0.673,0.483,2.706,0.89,5.348,0.731c2.879-0.173,5.297-0.957,6.672-2.158 c-0.005-0.195-0.021-0.39-0.045-0.582C396.223,466.919,393.63,464.685,390.572,464.685z M388.412,471.2 c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85c1.02,0,1.85,0.83,1.85,1.85 C390.262,470.37,389.432,471.2,388.412,471.2z M393.15,470.292c-0.75,0-1.36-0.61-1.36-1.36s0.61-1.361,1.36-1.361 c0.75,0,1.361,0.61,1.361,1.361S393.9,470.292,393.15,470.292z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M406.575,466.552c-0.295-0.116-0.806-0.309-1.382-0.237 c-0.551,0.068-0.844,0.34-0.844,1.007v0.866h2.228v1.717h-2.228v5.455h-1.932v-5.455h-1.34v-1.717h1.34v-0.888 c0-1.68,0.896-2.783,2.568-2.783c0.643,0,1.157,0.122,1.59,0.308L406.575,466.552z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M411.278,469.884c-0.177-0.03-0.358-0.046-0.526-0.046 c-0.896,0-1.51,0.548-1.51,1.613v3.908h-1.932v-7.172h1.873v0.785c0.451-0.673,1.14-0.977,2.021-0.977 c0.414,0,0.848,0.128,1.094,0.337L411.278,469.884z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M418.945,471.762c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.133,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.626-3.797C417.524,467.995,418.937,469.527,418.945,471.762z  M413.83,471.096h3.175c-0.177-0.918-0.733-1.436-1.562-1.436C414.534,469.66,414.001,470.208,413.83,471.096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M426.598,471.762c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.932,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C425.177,467.995,426.591,469.527,426.598,471.762z  M421.484,471.096h3.175c-0.178-0.918-0.733-1.436-1.562-1.436C422.187,469.66,421.654,470.208,421.484,471.096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M434.944,471.77c0,2.154-1.495,3.775-3.471,3.775 c-0.962,0-1.643-0.378-2.109-0.933v3.708h-1.924v-10.133h1.887v0.792c0.466-0.585,1.155-0.984,2.139-0.984 C433.449,467.995,434.944,469.616,434.944,471.77z M429.267,471.77c0,1.132,0.748,1.976,1.843,1.976 c1.14,0,1.85-0.881,1.85-1.976c0-1.095-0.71-1.976-1.85-1.976C430.014,469.794,429.267,470.637,429.267,471.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M438.047,465.841c0,0.696-0.54,1.229-1.236,1.229 c-0.696,0-1.229-0.533-1.229-1.229c0-0.696,0.533-1.243,1.229-1.243C437.507,464.598,438.047,465.146,438.047,465.841z  M437.788,475.359h-1.932v-7.172h1.932V475.359z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    style: {
      fill: "#1C1C1B"
    },
    d: "M441.012,470.741l2.701-2.554h2.368l-3.479,3.375l3.501,3.797h-2.376l-2.716-2.901 v2.901h-1.932v-10.658h1.932V470.741z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M309.392,475.294v-1.055c-0.527,0.718-1.391,1.231-2.388,1.231c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.388,1.245v-3.765h1.099v9.77H309.392z M309.392,473.376v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.724,2.27,2.724 C308.147,474.489,308.997,473.991,309.392,473.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M311.912,471.75c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.182-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C313.42,475.47,311.912,473.962,311.912,471.75z M315.383,468.952c-1.509,0-2.256,1.274-2.314,2.358h4.643 C317.697,470.255,316.994,468.952,315.383,468.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M319.587,474.357l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.098,0.952-2.036,2.636-2.036c1.201,0,2.051,0.454,2.622,1.026l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.552,4.38,0.527,4.38,3.281 c0,1.187-0.952,2.139-2.783,2.139C321.286,475.47,320.304,475.119,319.587,474.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M326.457,466.477c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C326.794,467.209,326.457,466.887,326.457,466.477z M326.647,475.294v-7.075h1.099v7.075H326.647 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M329.562,477.111l0.556-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.513,0.718-1.377,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.27,1.289-3.677,3.149-3.677 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.099v6.87c0,2.344-1.641,3.076-3.369,3.076 C331.217,478.165,330.396,477.931,329.562,477.111z M334.688,473.259v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.27,1.128-2.27,2.695c0,1.553,0.849,2.695,2.27,2.695C333.458,474.416,334.307,473.874,334.688,473.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M342.393,475.294v-4.629c0-1.245-0.63-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.17 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.465-1.201,2.519-1.201c1.48,0,2.256,0.747,2.256,2.285v4.966H342.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M344.912,471.75c0-2.051,1.465-3.706,3.486-3.706c2.138,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.893l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C346.421,475.47,344.912,473.962,344.912,471.75z M348.384,468.952c-1.509,0-2.256,1.274-2.314,2.358h4.643 C350.698,470.255,349.995,468.952,348.384,468.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M358.33,475.294v-1.055c-0.527,0.718-1.391,1.231-2.388,1.231c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.099v9.77H358.33z M358.33,473.376v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.849,2.724,2.27,2.724 C357.085,474.489,357.934,473.991,358.33,473.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M364.672,475.294v-9.77h1.099v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.845,0,3.149,1.465,3.149,3.721c0,2.299-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.231v1.055H364.672z  M367.879,474.489c1.436,0,2.286-1.157,2.286-2.724c0-1.568-0.85-2.739-2.286-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C366.151,473.991,367.015,474.489,367.879,474.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C1B"
    },
    d: "M372.508,477.067c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.806-0.161,1.055-0.747 l0.469-1.069l-2.959-7.148h1.187l2.358,5.801l2.344-5.801h1.201l-3.545,8.51c-0.425,1.025-1.143,1.421-2.08,1.435 c-0.234,0-0.601-0.044-0.806-0.103L372.508,477.067z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg46615252480558);
export default __webpack_public_path__ + "static/media/4661525_2480558.5fff31b796a9593e67c312b860606011.svg";
export { ForwardRef as ReactComponent };